export default [

/*
    {

        path: '/report/reports/list',
        name: 'report-reports-list',
        component: () => import('@/views/apps/report/reports/reports-list/ReportsList.vue'),
        meta: {
            resource: "report",
            action: 'read',
            pageTitle: 'Базовые отчеты old',
            breadcrumb: [
                {
                    text: 'Отчеты',
                    active: true,
                },
                {
                    text: 'Базовые отчеты',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/report/wrappers/list',
        name: 'report-wrappers-list',
        component: () => import('@/views/apps/report/wrappers/wrappers-list/WrappersList.vue'),
        meta: {
            resource: "report",
            action: 'read',
            pageTitle: 'Шаблонизированные отчеты old',
            breadcrumb: [
                {
                    text: 'Отчеты',
                    active: true,
                },
                {
                    text: 'Шаблонизированные отчеты',
                    active: true,
                },
            ],
        },
    },

*/

    {

        path: '/report/base',
        name: 'report-base',
        component: () => import('@/views/apps/report/base_report/BaseReport.vue'),
        meta: {
            resource: "report",
            action: 'read',
            pageTitle: 'Базовые отчеты',
            breadcrumb: [
                {
                    text: 'Отчеты',
                    active: true,
                },
                {
                    text: 'Базовые отчеты',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/report/wrapped',
        name: 'report-wrapped',
        component: () => import('@/views/apps/report/wrapped_report/WrappedReport.vue'),
        meta: {
            resource: "report",
            action: 'read',
            pageTitle: 'Шаблонизированные отчеты',
            breadcrumb: [
                {
                    text: 'Отчеты',
                    active: true,
                },
                {
                    text: 'Шаблонизированные отчеты',
                    active: true,
                },
            ],
        },
    },

]
